import VueCardFormat from 'vue-credit-card-validation';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueCardFormat);
});
